import { useQuery } from "@tanstack/react-query";
import type { CartCount } from "@spare-cart/contracts/cart";
import { apiClient } from "@core/api";
import { SessionStatus, selectStatus, useSession } from "@core/auth";
import { cartKeys } from "@modules/shared";

export const useCartCount = () => {
  const status = useSession(selectStatus);
  return useQuery({
    queryKey: cartKeys.count(),
    queryFn: () => apiClient.get<CartCount>("/cart/count"),
    enabled: status === SessionStatus.AUTHENTICATED,
  });
};
